import React from 'react';

function CarCard ({carDetails, onClick}) {
	return (
		<div onClick={() => onClick(carDetails.id)}>
			<img alt={''} style={{
				height: 20,
				width: 20
			}} src={carDetails.image} />
			<span>{carDetails.name}</span>
		</div>
	)
}

export default CarCard
